/**
 * SystemItrack
 * @author Thacryba
 */
import {Resource} from 'simpli-web-sdk'

export class SystemItrack extends Resource {
  idSystemPk: number = 0

  description: string | null = null

  get $id() {
    return this.idSystemPk
  }
  set $id(val) {
    this.idSystemPk = val
  }
  get $tag() {
    return String(this.description)
  }
}
